<template>
  <v-dialog v-model="value" :width="width" persistent>
    <v-card>
      <v-card-title primary-title class="px-2 py-1 mb-4 grey4">
        <div class="px-2">{{title}}</div>
        <v-spacer/>
        <v-btn class="ma-0" icon @click="$emit('input',false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <slot class="pt-2"/>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      default: false,
      required: true
    },
    title: {
      default: "Form Title"
    },
    width: {
      default: "700"
    }
  }
};
</script>